import { useEffect, useState } from "react";
import HrmsSyncApi from "../services/hrms_sync.api";
import { dsButtonPrimary, joinButtonClasses } from "../utils/buttonStyles";

const HRMSSyncPage = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [sdkToken, setSdkToken] = useState(null);
  const [connectionStatus, setConnectionStatus] = useState(null);

  useEffect(() => {
    // load a script
    setIsLoading(true);
    loadSDK();
    fetchAccessToken().then(() => {
      setIsLoading(false);
    });
  }, []); // empty dependency array to run only once on mount

  const loadSDK = () => {
    const script = document.createElement("script");
    script.src = "https://hrms-sdk.tartanhq.com/v1/sync-sdk.js"; // replace with your script URL
    script.async = true;
    document.body.appendChild(script);
    // cleanup function to remove the script
  };

  const fetchAccessToken = async () => {
    HrmsSyncApi.get_hrms_sync_integration({}, fetchSuccess, fetchError);
  }

  const fetchSuccess = (response) => {
    if (response.data && response.data.sdk_token) {
      setSdkToken(response.data.sdk_token);
      setConnectionStatus(response.data.status);
    }  
  }
  
  const fetchError = (error) => {
    console.error("Error fetching HRMS sync integration:", error);
    // Handle the error appropriately, e.g., show a notification or alert
  }
  
  const handleButtonClick = () => {
    // Call the function from the loaded script
    const options = {
      mode: "prod",
      onEvent: function (eventName, eventData) {
        console.log(eventName, eventData);
      },
    };

    window.hrmsSyncSdk.startJourney(
      sdkToken,
      options
    );
  };

  const terminateConnection = () => {
    HrmsSyncApi.terminateConnection({ method: 'post'}, terminateSuccess, terminateError);
  }

  const terminateSuccess = (response) => {
    fetchAccessToken(); // Refresh the connection status
  }  

  const terminateError = (error) => {
  }

  return (
    <div className="h-screen bg-gray-50 flex flex-col justify-start items-center pt-16">
      {/* Header Section */}
      <div className="text-center mb-8">
        <h1 className='font-fig-extrabold text-3xl font-medium leading-tight tracking-tight text-gray-900 sm:text-4xl'>HRMS Integration</h1>
        <p className="text-gray-600 mt-2">
          Seamlessly connect your HRMS system to streamline your workflows and improve efficiency.
        </p>
      </div>

      {/* Conditional Rendering Based on Connection Status */}
      {connectionStatus !== 'connected' ? (
        <div>
          <button
            className={joinButtonClasses(dsButtonPrimary, 'h-11 px-8 shadow-md hover:shadow-lg')}
            onClick={handleButtonClick}
          >
            Connect to HRMS
            {isLoading && <span className="ml-2 animate-pulse">Loading...</span>}
          </button>
        </div>
      ) : (
        <div className="text-center">
          <p className="text-lg font-semibold text-green-600 mb-4">
            Integration is connected successfully! Employee data sync in progress
          </p>
          <button
            className="border border-red-500 rounded-lg bg-red-500 text-white px-6 py-2 font-semibold shadow-md hover:bg-red-600 hover:shadow-lg transition-all duration-300 ease-in-out"
            onClick={terminateConnection}
          >
            Disconnect
          </button>
        </div>
      )}

      {/* Footer Section */}
      <div className="mt-8 text-center text-sm text-gray-500">
        <p>
          Need help? Visit our <a href="/support" className="text-blue-500 hover:underline">Support Center</a> or contact us at <a href="mailto:support@ekincare.com" className="text-blue-500 hover:underline">support@ekincare.com</a>.
        </p>
      </div>
    </div>
  );
};

export default HRMSSyncPage;
